//========================================================================================
// import { GestureHandlerRootView } from 'react-native-gesture-handler';
import EStylesheet from "react-native-extended-stylesheet"
import { Platform } from "react-native"
import Home from "./homePage";
//--------------------------------------------------------
EStylesheet.build({
   $appFont: 'IRANSansMobile',
   $appFontBold: Platform.OS === "ios" ? 'IRANSansMobile' : 'IRANSansMobile_Bold',

   $statusBarColor: "#00ACC1", //800
   $headerColor: '#00ACC1',    //600
   $headerColor_searchMode: "#FFFFFF",
   $headerTextColor_searchMode: "#00ACC1",
   $headerIconColor: "#FFFFFF",
   $headerTextColor: "#FFFFFF",

   $buttonColor: "#00bcd4",
   $buttonTextColor: '#ffffff',

   $textColor: '#456e7a',
   $itemKeyColor: "#546e7a",
   $itemValueColor: 'brown',

   $waitColor: "#B0BEC5",

   $tinyFont: Platform.OS === "ios" ? 12 : 12,
   $smallFont: Platform.OS === "ios" ? 14 : 14,
   $normalFont: Platform.OS === "ios" ? 15 : 15,
   $bigFont: Platform.OS === "ios" ? 17 : 17,
})



const App = (props) => {

   return <Home />
}

export default App;
//=========================================================================================